export default {
  title: {
    it: 'Crea il tuo avatar!',
    de: 'Erstelle deinen Avatar!',
    fr: 'Crée ton avatar !',
    en: 'Create Your Avatar!'
  },

  description: {
    it: 'Crea gli avatar della tua famiglia e preparati a sfide divertenti.',
    de: 'Gestalte lustige Avatare für jedes Familienmitglied und mach dich bereit für spannende Challenges!',
    fr: 'Crée des avatars amusants pour chaque membre de la famille et prépare-toi à relever des défis !',
    en: 'Design fun avatars for every family member and get ready for fun challenges!'
  },

  membersLabel: {
    it: 'Numero di membri della famiglia',
    de: 'Anzahl Familienmitglieder',
    fr: 'Nombre de membres de la famille',
    en: 'Number of family members'
  },

  button: {
    it: 'Avanti',
    de: 'Weiter',
    fr: 'Continuer',
    en: 'Okay!'
  }
};
